import axios from 'axios';
import React from 'react';
import { Countries } from '../../constants/Countries';
import { formDataValidate, validateAlphanumeric } from '../../utils/formUtils';
import CustomSelect from '../form-controls/custom-select/Custom-Select';
import CustomTextField from '../form-controls/custom-text-field/Custom-Text-Field';
import LocationInput from '../google-location-input/LocationInput';
import LocationMap from '../google-map/LocationMap';

const LocationInputTab = (props) => {
  const { formData, setFormData } = props;

  const validate = (tabValue) => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onLocationSelect = async (locObj) => {
    let addressLine1 = '';
    let addressLine2 = '';
    let country = '';
    let state = '';
    let postalCode = '';
    let city = '';
    const latitude = locObj.geometry.location.lat();
    const longitude = locObj.geometry.location.lng();
    let timeZone = '';
    const currFormData = { ...formData };

    locObj.address_components.forEach((item) => {
      if (item.types.includes('street_number')) {
        addressLine1 = item.long_name;
        return;
      }

      if (item.types.includes('route')) {
        addressLine1 += ` ${item.long_name}`;
        return;
      }

      if (item.types.includes('neighborhood') && item.types.includes('political')) {
        addressLine2 = item.long_name;
        return;
      }

      if (item.types.includes('country') && item.types.includes('political')) {
        country = item.long_name;
        return;
      }

      if (item.types.includes('administrative_area_level_1') && item.types.includes('political')) {
        state = item.long_name;
        return;
      }

      if (item.types.includes('postal_code')) {
        postalCode = item.long_name;
        return;
      }

      if (item.types.includes('locality') && item.types.includes('political')) {
        city = item.long_name;
      }
    });

    try {
      const timeInSecs = new Date().getTime() / 1000;
      const res = await axios.get(
        `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude}%2C${longitude}&timestamp=${timeInSecs}&key=AIzaSyAa_UAQQDPYFCyHvbDG4rlkxFYk1vgLFkM`,
      );

      if (res.data && res.data.status === 'OK' && res.data.timeZoneName) {
        timeZone = res.data.timeZoneName;
      }
    } catch (err) {
      console.error(err);
    }

    currFormData.addressLine1.value = addressLine1 || locObj.vicinity;
    currFormData.addressLine2.value = addressLine2;
    currFormData.country.value = country;
    currFormData.state.value = state;
    currFormData.postalCode.value = postalCode;
    currFormData.city.value = city;
    currFormData.latitude.value = latitude;
    currFormData.longitude.value = longitude;
    currFormData.timeZone.value = timeZone;
    setFormData(currFormData);
    validate(3);
  };

  const onChangePostalCode = (e) => {
    if (e.value) {
      const isValid = validateAlphanumeric(e.value);
      if (!isValid) return false;
    }
    setFormData({ postalCode: e });
  };

  return (
    <div className='col-md-12 mb-3'>
      <h4 className='tab-title'>Location</h4>
      <div className='row'>
        <div className='col-md-12 mb-3'>
          <LocationInput onLocationSelect={onLocationSelect} />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.addressLine1}
            handleInputChange={(e) => {
              setFormData({ addressLine1: e });
            }}
            maxLength='150'
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.addressLine2}
            handleInputChange={(e) => {
              setFormData({ addressLine2: e });
            }}
            maxLength='150'
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomSelect
            item={formData.country}
            handleInputChange={(e) => {
              setFormData({ country: e });
            }}
            labelField='name'
            valueField='name'
            labelPrefix='Select'
            options={Countries}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.state}
            handleInputChange={(e) => {
              setFormData({ state: e });
            }}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.postalCode}
            handleInputChange={(e) => onChangePostalCode(e)}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.city}
            handleInputChange={(e) => {
              setFormData({ city: e });
            }}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.latitude}
            handleInputChange={(e) => {
              setFormData({ latitude: e });
            }}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.longitude}
            handleInputChange={(e) => {
              setFormData({ longitude: e });
            }}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.area}
            handleInputChange={(e) => {
              setFormData({ area: e });
            }}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.timeZone}
            handleInputChange={(e) => {
              setFormData({ timeZone: e });
            }}
          />
        </div>
      </div>
      <div className='row'>
        <div
          className={`col-md-10 ${
            !(formData?.latitude && formData?.longitude) && 'disabled-container'
          }`}
        >
          <LocationMap lat={formData.latitude.value} lng={formData.longitude.value} />
        </div>
      </div>
    </div>
  );
};

export default LocationInputTab;
